export default "__VITE_ASSET__92180213__"